export enum SwipeDirections {
  UP = 'Up',
  DOWN = 'DOWN',
}
